<template>
    <div class="nothing">
        <div class="wrap">
            <el-empty :description="text"></el-empty>
        </div>
        
    </div>
  </template>
  
  <script>
  export default {
    props: {
      text: {
        type: String,
        default: '暂无数据信息',
      },
    },
    name: "SmsSend",
    components: {},
    data() {
      // 这里存放数据
      return {
        
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
  
    },
    // 方法集合
    methods: {
      
    },
  }
  </script>
  
  <style lang="scss" scoped>
    .nothing{
        min-height: 400px;
        width: 100%;
        display: flex;
        align-items: center;
        .wrap{
            margin: 0 auto;
        }
    }
  </style>